import { render, staticRenderFns } from "./Employee.vue?vue&type=template&id=27553574&scoped=true"
import script from "./Employee.vue?vue&type=script&lang=js"
export * from "./Employee.vue?vue&type=script&lang=js"
import style0 from "./Employee.vue?vue&type=style&index=0&id=27553574&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27553574",
  null
  
)

export default component.exports